import { Skeleton, Stack } from "@mui/material";
import React from 'react';

export function DetectorsListSkeleton() {
  return (
    <Stack data-testid="skeleton" direction="column" spacing={4}>
      <Skeleton variant="rectangular" className="w-full h-[170px] md:h-[200px] mt-[10px] md:mt-[20px]" />
      <Skeleton variant="rectangular" className="w-full h-[170px] md:h-[200px] mt-[20px] md:mt-[40px]" />
      <Skeleton variant="rectangular" className="w-full h-[170px] md:h-[200px] mt-[20px] md:mt-[40px]" />
      <Skeleton variant="rectangular" className="w-full h-[170px] md:h-[200px] mt-[20px] md:mt-[40px]" />
    </Stack>
  );
}
